import React from 'react';

interface SocialIconProps {
  children: React.ReactNode;
  href?: string;
  ariaLabel: string;
}

export const SocialIcon: React.FC<SocialIconProps> = ({ children, href = '#', ariaLabel }) => (
  <a
    href={href}
    aria-label={ariaLabel}
    className='text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-ring rounded-sm p-1'
    target='_blank'
    rel='noopener noreferrer'
  >
    {children}
  </a>
);
